<template>
  <div class="datepicker-trigger"
  >
    <span id="datepicker-trigger" style="visibility: hidden; position: absolute; right: 0"></span>
    <span class="cursor-pointer dropdown no-drag font-weight-bold "
      v-bind:class="(btn ? 'btn btn-outline-muted' : 'highlight-btn') + ' datepicker-' + module"
      :style="custom?'background-color: white !important;padding: 0px !important;':''"
      @click="openOption"
    >
      <font-awesome-icon icon="calendar-alt" class="mr-1 text-muted" />

      {{ t(displayDate) }}
      <font-awesome-icon icon="caret-down" class="ml-1" />
    </span>

    <transition name="fade">
      <div
        class="dropdown-content-datepicker"
        v-on-clickaway="hideContent"
        v-if="showDateOption"
      >
        <span id="abnb-today" v-if="this.module === 'testreport'" @click="getDates('all')">{{ t('All Time') }}</span>
        <hr v-if="this.module === 'testreport'">
        <span id="abnb-today" v-if="this.module !== 'testreport'" @click="getDates('today')">{{ t('Today') }}</span>
        <span id="abnb-yesterday" v-if="this.module !== 'testreport'" @click="getDates('yesterday')">{{
          t('Yesterday')
        }}</span>
        <span id="abnb-past7" @click="getDates('past7days')">{{
          t('Last 7 days')
        }}</span>
        <span id="abnb-past30" @click="getDates('past30days')">{{ t('Last 30 days') }}</span>
        <hr v-if="this.module === 'testreport'">
        <span id="abnb-today" v-if="this.module === 'testreport'" @click="getDates('thismonth')">{{ t('Month to date') }}</span>
        <span id="abnb-today" v-if="this.module === 'testreport'" @click="getDates('lastmonth')">{{ t('Last Month') }}</span>
        <hr v-if="this.module === 'testreport'">
        <span
          id="datepicker-trigger"
          @click="
            showDatepicker = true
            showDateOption = false
          "
          >{{ t('Custom Range') }}</span
        >
      </div>
    </transition>

    <!-- style="background-color: #008489; color: #ffffff;" -->
    <AirbnbStyleDatepicker
      :trigger-element-id="'datepicker-trigger'"
      :mode="'range'"
      :fullscreen-mobile="false"
      :date-one="dateOne"
      :date-two="dateTwo"
      @date-one-selected="
        (val) => {
          dateOne = val
        }
      "
      @date-two-selected="
        (val) => {
          dateTwo = val
        }
      "
      @apply="onApplyMethod()"
      @cancelled="onCancelledMethod"
      @opened="onOpenedMethod"
      @closed="onClosedMethod()"
      :showShortcutsMenuTrigger="true"
      :trigger="showDatepicker"
      :months-to-show="month2show"
      :minDate="minDate"
      :endDate="maxDate"
    />
  </div>
</template>

<script>
import format from 'date-fns/format'
import { store } from '@/store'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  store,
  props: ['module', 'custom-class', 'custom', 'minDate', 'maxDate', 'btn'],
  data() {
    return {
      dateFormat: 'MMM DD',
      dateOne: this.getInit('start'),
      dateTwo: this.getInit('end'),
      originalDateOne: '',
      originalDateTwo: '',
      showDateOption: false,
      showDatepicker: false,
      month2show: 2,
      displayDate: 'Pass Week',
      adjustDropdown: false,
      secretPosition:17,
      custom: false
    }
  },
  created() {
    document.addEventListener('resize', this.calculateMonth2Show)
    if (document.addEventListener) { window.addEventListener('resize', this.calculateMonth2Show) }
    if (document.attachEvent) { window.attachEvent('onresize', this.calculateMonth2Show) }
  },
  watch: {
    '$store.getters.datepicker.dashboard': {
      handler: function (date) {
        this.dateOne = date.startDate
        this.dateTwo = date.endDate
        this.onApplyMethod()
      },
      deep: true,
    },
    '$store.getters.datepicker.testreport': {
      handler: function (date) {
        this.dateOne = date.startDate
        this.dateTwo = date.endDate
        this.onApplyMethod()
      },
      deep: true,
    }    
  },
  mounted() {
    // First check URL parameters
    if (this.$route.query.startDate || this.$route.query.endDate) {
      // If URL has date parameters, use them
      this.dateOne = this.$route.query.startDate || null
      this.dateTwo = this.$route.query.endDate || null
      
      // Update store with URL parameters
      this.$store.commit('setDatepicker', {
        module: this.module,
        name: 'startDate',
        data: this.dateOne
      })
      this.$store.commit('setDatepicker', {
        module: this.module,
        name: 'endDate',
        data: this.dateTwo
      })
    } else {
      // If no URL parameters, apply default date logic
      if (Number(this.$session.get('user_id')) === 2572) {
        this.getDates('past30days')
      } else if (this.module === 'dashboard' && this.$isHowuku && (window.location.host === 'app.howuku.com' || window.location.host === 'localhost:8080' || window.location.host === 'optimize.howuku.com')){
        this.getDates('past7days')
      } else if (this.module === 'dashboard' && !this.$isHowuku ){
        this.getDates('past7days')
      } else if (this.module === 'testreport'){
        this.getDates('all')
      } else if (this.$route.params.encryptedParam){
        this.getDates('past7days')
      }
    }

    // Update display date
    this.displayDate = this.getDateText(
      this.$store.getters.datepicker[this.module].startDate,
      this.$store.getters.datepicker[this.module].endDate
    )
  },
  methods: {
    openOption(){
      if (this.custom) {
        this.showDatepicker = true 
        this.showDateOption = false
      }
      else this.showDateOption = !this.showDateOption
    },
    onApplyMethod() {
      this.showDatepicker = false

      this.$store.commit('setDatepicker', {
        module: this.module,
        name: 'startDate',
        data: this.dateOne
      })
      this.$store.commit('setDatepicker', {
        module: this.module,
        name: 'endDate',
        data: this.dateTwo
      })

      var query = {
        ...this.$route.query,
        startDate: this.dateOne,
        endDate: this.dateTwo
      }
      if (this.dateOne && this.dateTwo) this.$router.replace({ query })

      // this.displayDate = this.dateOne + '-' + this.dateTwo
      this.displayDate = this.getDateText(
          this.$store.getters.datepicker[this.module].startDate,
          this.$store.getters.datepicker[this.module].endDate
      )
    },
    onClosedMethod() {
      this.$store.commit('setDatepicker', {
        module: this.module,
        name: 'startDate',
        data: this.dateOne
      })
      this.$store.commit('setDatepicker', {
        module: this.module,
        name: 'endDate',
        data: this.dateTwo
      })

      var query = {
        ...this.$route.query,
        startDate: this.dateOne,
        endDate: this.dateTwo
      }
      if (this.dateOne && this.dateTwo) this.$router.replace({ query })

      this.showDatepicker = false
      this.displayDate = this.formatDates(this.dateOne, this.dateTwo)
    },
    onCancelledMethod() {
      this.dateOne = this.originalDateOne
      this.dateTwo = this.originalDateTwo
    },
    onOpenedMethod() {
      this.originalDateOne = this.dateOne
      this.originalDateTwo = this.dateTwo
    },
    getInit(value) {
      if (value === 'start') {
        if (this.$store.getters.datepicker[this.module].startDate) {
          return this.$store.getters.datepicker[this.module].startDate
        } else if (Number(this.$session.get('user_id')) === 2572) {
          this.displayDate = 'Last 30 days'
          return this.$userTimeNow().add(-30, 'day').format('YYYY-MM-DD')
        }
        return this.$userTimeNow().format('YYYY-MM-DD')
      }

      if (value === 'end') {
        if (this.$store.getters.datepicker[this.module].endDate) { return this.$store.getters.datepicker[this.module].endDate } else if (Number(this.$session.get('user_id')) === 2572) {
          return this.$userTimeNow().format('YYYY-MM-DD')
        }
        return null
      }
    },
    calculateMonth2Show() {
      let w =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      this.month2show = 2
      if (w < 800) this.month2show = 1
    },
    init() {
      this.dateOne = this.$userTimeNow().add(-7, 'day').format()
      this.dateTwo = this.$userTimeNow().format()

      this.$store.commit('setDatepicker', {
        module: this.module,
        name: 'startDate',
        data: this.dateOne
      })

      this.$store.commit('setDatepicker', {
        module: this.module,
        name: 'endDate',
        data: this.dateTwo
      })
    },
    hideContent() {
      this.showDateOption = false
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = ''
      let isSameDate = false

      if (dateOne) {
        formattedDates += format(dateOne, this.dateFormat)
      }

      if (typeof dateOne === 'string' && typeof dateTwo === 'string') {
        isSameDate = dateOne === dateTwo
      }

      if (dateTwo && !isSameDate) {
        formattedDates += ' — ' + format(dateTwo, this.dateFormat)
      }
      return formattedDates
    },
    getDates(value) {
      // this.adjustDropdown = false
      // if (
      //   this.module === 'form' ||
      //   this.module === 'funneldetails' ||
      //   this.module === 'poll' ||
      //   this.module === 'eventdetails'
      // )
      //   this.adjustDropdown = true
      // else document.body.style.setProperty('--dropdown', '0')
      // time info is handled in backend
      switch (value) {
        case 'all':
          // if (this.adjustDropdown)
          //   document.body.style.setProperty('--dropdown', '-110px')
          this.dateOne = null
          this.dateTwo = null
          this.displayDate = 'All Time'
          break        
        case 'today':
          // if (this.adjustDropdown)
          //   document.body.style.setProperty('--dropdown', '-110px')
          this.dateOne = this.$userTimeNow().format('YYYY-MM-DD')
          this.dateTwo = null
          this.displayDate = 'Today'
          break
        case 'yesterday':
          // if (this.adjustDropdown)
          //   document.body.style.setProperty('--dropdown', '-84px')
          this.dateOne = this.$userTimeNow()
            .add(-24, 'hour')
            .format('YYYY-MM-DD')
          this.dateTwo = null
          this.displayDate = 'Yesterday'
          break
        case 'past7days':
          // if (this.adjustDropdown)
          //   document.body.style.setProperty('--dropdown', '-82px')
          this.dateOne = this.$userTimeNow().add(-7, 'day').format('YYYY-MM-DD')
          this.dateTwo = this.$userTimeNow().format('YYYY-MM-DD')
          this.displayDate = 'Last 7 days'
          break
        case 'thisweek':
          // if (this.adjustDropdown)
          //   document.body.style.setProperty('--dropdown', '-82px')
          this.dateOne = this.$userTimeNow()
            .weekday(1)
            .utcOffset(0)
            .format('YYYY-MM-DD')
          this.dateTwo = this.$userTimeNow().weekday(7).format('YYYY-MM-DD')
          this.displayDate = 'This week'
          break
        case 'lastweek':
          // if (this.adjustDropdown)
          //   document.body.style.setProperty('--dropdown', '-82px')
          this.dateOne = this.$userTimeNow()
            .weekday(1)
            .weekday(-6)
            .format('YYYY-MM-DD')
          this.dateTwo = this.$userTimeNow()
            .weekday(1)
            .add(-1, 'day')
            .format('YYYY-MM-DD')
          this.displayDate = 'Last week'
          break
        case 'thismonth':
          // if (this.adjustDropdown)
          //   document.body.style.setProperty('--dropdown', '-76px')
          this.dateOne = this.$userTimeNow()
            .startOf('month')
            .format('YYYY-MM-DD')
          this.dateTwo = this.$userTimeNow().endOf('month').format('YYYY-MM-DD')
          this.displayDate = 'Month to date'
          break
        case 'lastmonth':
          this.dateOne = this.$userTimeNow()
            .subtract(1, 'month')
            .startOf('month')
            .format('YYYY-MM-DD')
          this.dateTwo = this.$userTimeNow()
            .subtract(1, 'month')
            .endOf('month')
            .format('YYYY-MM-DD')
          this.displayDate = 'Last month'
          break
        case 'past30days':
          // if (this.adjustDropdown)
          //   document.body.style.setProperty('--dropdown', '-76px')
          this.dateOne = this.$userTimeNow()
            .add(-30, 'day')
            .format('YYYY-MM-DD')
          this.dateTwo = this.$userTimeNow().format('YYYY-MM-DD')
          this.displayDate = 'Last 30 days'
          break
        default:
          this.displayDate = 'Last 7 days'
          break
      }

      if(!(this.$store.getters.datepicker.dashboard.startDate === this.dateOne &&  this.$store.getters.datepicker.dashboard.endDate && this.dateTwo)){
        if (this.dateOne && this.dateTwo) {
          var query = {
            ...this.$route.query,
            startDate: this.dateOne,
            endDate: this.dateTwo
          }
          this.$router.replace({ query })
        } else {
          const { startDate, endDate, ...restQuery } = this.$route.query
          this.$router.replace({ query: restQuery })
        }
      }

      if(!(this.$store.getters.datepicker.testreport.startDate === this.dateOne &&  this.$store.getters.datepicker.testreport.endDate && this.dateTwo)){
        if (this.dateOne && this.dateTwo) {
          var query = {
            ...this.$route.query,
            startDate: this.dateOne,
            endDate: this.dateTwo
          }
          this.$router.replace({ query })
        } else {
          const { startDate, endDate, ...restQuery } = this.$route.query
          this.$router.replace({ query: restQuery })
        }
      }

      this.$store.commit('setDatepicker', {
        module: this.module,
        name: 'startDate',
        data: this.dateOne
      })
      this.$store.commit('setDatepicker', {
        module: this.module,
        name: 'endDate',
        data: this.dateTwo
      })

      this.$auditlog({ module: 'usage', action: 'filter_date' })  
    
      try{
        howuku.track('usage', { feature: 'filter_date' })
      }catch(e){}

      try{
        _cio.track('usage', { feature: 'filter_date', created_at: Math.round(new Date().getTime() / 1000) })
      }catch(e){}     

      this.showDateOption = false
    },
    getDateText(start, end) {
      if (this.$isMida && this.module === 'testreport' && !start && !end) return 'All Time'
      if (start === this.$userTimeNow().format('YYYY-MM-DD') && end === null) { return 'Today' }
      if (
        start === this.$userTimeNow().add(-24, 'hour').format('YYYY-MM-DD') &&
        end === null
      ) { return 'Yesterday' }

      if (
        start === this.$userTimeNow().add(-7, 'day').format('YYYY-MM-DD') &&
        end === this.$userTimeNow().format('YYYY-MM-DD')
      ) { return 'Last 7 days' }

      if (
        start ===
          this.$userTimeNow().weekday(1).utcOffset(0).format('YYYY-MM-DD') &&
        end === this.$userTimeNow().weekday(7).format('YYYY-MM-DD')
      ) { return 'This week' }
      if (
        start ===
          this.$userTimeNow().weekday(1).weekday(-6).format('YYYY-MM-DD') &&
        end ===
          this.$userTimeNow().weekday(1).add(-1, 'day').format('YYYY-MM-DD')
      ) { return 'Last week' }

      if (
        start === this.$userTimeNow().startOf('month').format('YYYY-MM-DD') &&
        end === this.$userTimeNow().endOf('month').format('YYYY-MM-DD')
      ) { return 'Month to date' }

      if (
        start === this.$userTimeNow().add(-30, 'day').format('YYYY-MM-DD') &&
        end === this.$userTimeNow().format('YYYY-MM-DD')
      ) { return 'Last 30 days' }

      return this.formatDates(start, end)
    },
    // methods for parent pages
    setCustomDisplayDate(dateOne, dateTwo) {
      //this.displayDate = this.formatDates(dateOne, dateTwo)
      this.displayDate = this.getDateText(dateOne, dateTwo)
    },
    reloadDisplayDate() {
      this.displayDate = this.getDateText(
        this.$store.getters.datepicker[this.module].startDate,
        this.$store.getters.datepicker[this.module].endDate
      )
    }
  }
}
</script>

<style>
.make-link {
  cursor: pointer;
  font-weight: 500 !important;
}
/* :root {
  --dropdown: 0;
} */
.make-link:hover {
  color: #044b55;
}

.dropdown-content-datepicker {
  position: absolute;
  background-color: var(--background);
  margin-top: 15px;
  left: 0;
  min-width: 220px;
  border: 1px solid #ced4da;
  -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11),
    0 1px 3px rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  padding: 2px 0;
  text-align: left;
  z-index: 10;
}

.from-right .dropdown-content-datepicker {
  right: 0 !important;
  left: auto;
}

.dropdown-content-datepicker span {
  color: var(--color);
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  cursor: default;
}

.dropdown-content-datepicker span:hover {
  background-color: rgba(var(--main-color), 0.2);
}

.dropdown-content-datepicker > hr {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}

.dropdown-divider {
  background-color: #dbdbdb;
  border: none;
  display: block;
  height: 1px;
  margin: 0.5rem 0;
}

hr {
  box-sizing: content-box;
  height: 0;
}

.date-wrap,
.name-wrap {
  /* border: 2px solid #c6cacf; */
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.0666667) 0px 1px 6px;
  border-radius: 5px;
  padding: 10px 20px;
  display: inline-block;
}
.highlight-btn {
  background-color: var(--background);
  color: var(--color);
  padding: 10px;
  border-radius: 8px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/AirbnbDatePicker.vue